import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { ErrorMessage, ErrorText } from './styles';

/**
 * This component is responsible for displaying a validation error
 */
function ErrorDisplay({ className, errorMessage }) {
  return (
    <ErrorMessage className={className}>
      <FontAwesomeIcon icon={faExclamationTriangle} />
      <ErrorText>{errorMessage}</ErrorText>
    </ErrorMessage>
  );
}

ErrorDisplay.propTypes = {
  className: PropTypes.string,
  errorMessage: PropTypes.string,
};

ErrorDisplay.defaultProps = {
  className: '',
  errorMessage: 'Please fill in a valid value.',
};

export default ErrorDisplay;
